// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"94631127","453":"27466269","556":"37658700","602":"a1b8084c","612":"426dec80","661":"cb03c0f1"}[chunkId] + ".chunk.js";
};